import React from 'react'

const WebhookIcon = () => {
  return (
    <svg
      width="70"
      height="58"
      viewBox="0 0 70 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 15C15.9706 15 20 10.9706 20 6C20 5.88844 19.998 5.77734 19.9939 5.66676C23.2906 3.96252 27.0329 3 31 3C44.2548 3 55 13.7452 55 27C55 40.2548 44.2548 51 31 51C17.7452 51 7 40.2548 7 27C7 22.6151 8.17592 18.5049 10.2296 14.9675C10.4836 14.989 10.7405 15 11 15Z"
        fill="#09AA89"
      />
      <path
        d="M20.7783 19.9609L18.1357 28.9629L15.4932 19.9609H11.4111L16.0732 35H19.167L22.0674 25.7617L24.9678 35H28.04L32.7236 19.9609H28.9209L26.2568 28.9629L23.6143 19.9609H20.7783ZM44.1748 35H48.2139V19.9609H44.1748V25.8047H38.3955V19.9609H34.3564V35H38.3955V29.0918H44.1748V35Z"
        fill="white"
      />
      <path
        d="M60.0005 15L66 25C66 25 60.0174 22 60.0005 25C59.9836 28 60.0005 27.0001 60.0005 27.0001V15Z"
        fill="#69D5BA"
      />
      <path
        d="M60.0005 27.0001C60.0005 43.0163 47.0167 56.0001 31.0005 56.0001C14.9842 56.0001 2.00048 43.0163 2.00049 27.0001C2.00049 19.4677 4.87567 13.6014 7.92166 9.5M60.0005 27.0001V15L66 25C66 25 60.0174 22 60.0005 25C59.9836 28 60.0005 27.0001 60.0005 27.0001Z"
        stroke="#69D5BA"
        strokeWidth="3"
      />
      <path
        d="M17 6C17 9.31371 14.3137 12 11 12C7.68629 12 5 9.31371 5 6C5 2.68629 7.68629 0 11 0C14.3137 0 17 2.68629 17 6Z"
        fill="#018065"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9C12.6569 9 14 7.65685 14 6C14 4.34315 12.6569 3 11 3C9.34315 3 8 4.34315 8 6C8 7.65685 9.34315 9 11 9ZM11 12C14.3137 12 17 9.31371 17 6C17 2.68629 14.3137 0 11 0C7.68629 0 5 2.68629 5 6C5 9.31371 7.68629 12 11 12Z"
        fill="#69D5BA"
      />
    </svg>
  )
}

export default WebhookIcon
